/**
*
* FlexMedia
*
*/

import styled from 'styled-components';
import { Div } from '../Blocks';

export const FlexMedia = styled(Div)`
  position: relative;
  height: 0;
  padding-bottom: 55.5%;
  box-shadow: 0 0 4px 1px rgba(0,0,0,0.20);
  overflow: hidden;
  .widescreen {
    padding-bottom: 57.25%;
  }
  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media  only screen and (max-device-width: 800px),
    only screen and (device-width: 1024px) and (device-height: 600px),
    only screen and (width: 1280px) and (orientation: landscape),
    only screen and (device-width: 800px),
    only screen and (max-width: 767px) {
    padding-top: 0;
  }
`;
